<template>
  <div class="">
    <div class="status">
      <div class="spacer two-hour"></div
      ><div class="hour">8</div
      ><div class="hour">12</div
      ><div class="hour">16</div
      ><div class="hour">20</div>
    </div>
    <div class="blocks">
      <div v-for="booking in bookings" :key="booking.id" class="block" :style="getStyle(booking)"></div>
    </div>
  </div>
</template>

<script>

const HOUR_WIDTH = 5.55555555;

export default {
  name: 'RoomStatusBar',
  props: ['bookings'],
  methods: {
    getStyle (booking) {
      let start = booking.start.split(':')
      let end = booking.end.split(':')
      let duration = [ end[0] - start[0], end[1] - start[1] ]
      let left = start[0] * HOUR_WIDTH - 6 * HOUR_WIDTH + start[1] / 60 * HOUR_WIDTH
      let width = duration[0] * HOUR_WIDTH + duration[1] / 60 * HOUR_WIDTH
      return { left: left + '%', width: width + '%' }
    }
  },
  mounted () {
    // console.log('RoomStatusBar', this.bookings);
  }
}
</script>

<style lang="scss" scoped>

  @import 'src/color.scss';

  $hour-width: 5.5556%;

  .status {
  }

  .spacer.two-hour {
    width: ($hour-width * 2);
    display: inline-block;
  }

  .hour {
    // width: 20%;
    // width: 22.222%;
    width: ($hour-width * 4);
    display: inline-block;
    text-align: left;
    //border-left: 1px solid $primary-dark;
    padding-left: 0.2em;
    box-sizing: border-box;
  }

  .blocks {
    position: relative;
    height: 0.5em;
  }

  .block {
    box-sizing: border-box;
    //border-right: 1px solid $primary-light;
    //background: -webkit-linear-gradient(right, $secondary-light -40%, $secondary);
    background: $primary-text;
    // background: -webkit-radial-gradient($secondary-dark 10%, $secondary, $secondary-light);
    position: absolute;
    height: 0.5em;
    width: 6%;
  }

</style>



// WEBPACK FOOTER //
// src/components/RoomStatusBar.vue